import { Icon } from "@abb/abb-common-ux-react";
import { v4 as uuidv4 } from "uuid";
import React from "react";
import { Translation } from "react-i18next";
import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import deviceActions from "../../flux/actions/DeviceActions";
import instrumentActions from "../../flux/actions/InstrumentActions";
import loadingActions from "../../flux/actions/LoadingActions";
import deviceByIdStore from "../../flux/stores/device/ByIdStore";
import instrumentByIdStore from "../../flux/stores/instrument/ByIdStore";
import instrumentDeleteStore from "../../flux/stores/Instrument/DeleteStore";
import instrumentListStore from "../../flux/stores/instrument/ListStore";
import ConnectFormData from "../../models/device/ConnectFormData";
import {
  defaultDeviceViewData,
  IDeviceViewData,
} from "../../models/device/DeviceViewData";
import { InstrumentFormData } from "../../models/instrument/InstrumentFormData";
import {
  defaultInstrumentData,
  IInstrumentViewData,
} from "../../models/instrument/InstrumentViewData";
import IActionHeaderFormData, {
  IActionHeaderEditData,
} from "../../models/shared/ActionHeaderData";
import {
  ISidebarDetail,
  SidebarDetail,
} from "../../models/shared/SidebarDetail";
import * as CONSTANTS from "../../utilities/Constants";
import triggerNotifications from "../../utilities/TriggerNotifications";
import InstrumentSidebar from "../sharedNew/sidebar/InstrumentSidebar";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import IntrumentOverview from "./IntrumentOverview";
import i18next from "i18next";

interface Istate {
  collapseSidebar: boolean;
  listData: ISidebarDetail[];
  searchValue: string;
  activeId: string;
  activeConnectionItem: IDeviceViewData;
  activeItem: IInstrumentViewData;
}

export default class ManageInstrumentIndex extends React.Component<
  { location: any },
  Istate
> {
  private _listData: ISidebarDetail[] = [];
  private _id = "";
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _mount = false;
  private _reloadFirst = true;
  private _childRef: any;

  constructor(props: { location: any }) {
    super(props);

    this._childRef = React.createRef();
    this._mount = false;
    this.state = {
      collapseSidebar: false,
      listData: [],
      searchValue: "",
      activeId: this.props.location?.state ?? "",
      activeConnectionItem: defaultDeviceViewData,
      activeItem: defaultInstrumentData,
    };
  }

  private onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar,
    });
  };

  private setEditData() {
    const receivedData = this.state.activeItem;
    const receivedDeviceData = this.state.activeConnectionItem;
    const editData = {
      instrumentFormData: new InstrumentFormData(
        true,
        uuidv4(),
        receivedData.id,
        receivedData.name,
        receivedData.codeId,
        receivedData.serialNumber,
        receivedData.type,
        receivedData.directionList,
        receivedData.properties,
        receivedData.description,
        receivedData.isCreatedManually
      ),

      connectFormData: new ConnectFormData(
        receivedDeviceData.ipAddress,
        receivedDeviceData.username,
        "",
        false,
        receivedDeviceData.isAutoLine,
        receivedDeviceData.directory,
        Number(receivedDeviceData.pollingFrequency),
        receivedDeviceData.path,
        "",
        receivedDeviceData.connectionType,
        receivedDeviceData.connectionTypeId,
        [],
        receivedDeviceData.port
      ),
    };
    const data: IActionHeaderEditData = {
      moduleName: CONSTANTS.MODULE_INSTRUMENT,
      editData,
      deleteTitle: receivedData.name,
      deleteId: receivedData.id,
      deleteRequestId: uuidv4(),
      deleteMessage: i18next.t(CONSTANTS.DELETE_MESSAGE).format(
        receivedData.name,
        CONSTANTS.MODULE_INSTRUMENT.toLowerCase()
      ),
    };
    console.log(data, "data");
    actionHeaderActions.edit(data).then();
  }

  private triggerGetById(id: string) {
    instrumentActions
      .getById(id)
      .then(() => {
        deviceActions
          .getById(id)
          .then(() => {
            this.setEditData();
          })
          .catch((error: any) => {
            this.setState(
              {
                activeConnectionItem: defaultDeviceViewData,
              },
              this.setEditData
            );
            triggerNotifications.errors(error);
          });
      })
      .catch((error: any) => triggerNotifications.errors(error));
  }

  public onSearch = (value: any) => {
    if (value.length >= CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      instrumentActions
        .getAll(
          false,
          1,
          CONSTANTS.PAGE_SIZE,
          CONSTANTS.SORT_CREATEDON,
          CONSTANTS.SORT_ORDER,
          value
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState(
            { listData: this._listData, searchValue: value },
            () => {
              const firstItem = this.state.listData.find(
                (x) => x.id === this.state.activeId
              );
              if (this.state.listData.length > 0) {
                this.triggerGetById(firstItem?.id);
              }
            }
          );
        });
    } else {
      this.setState({ searchValue: value });
    }
  };

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  };

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
    instrumentActions
      .getAll(
        false,
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        this.state.searchValue
      )
      .then(() => {
        loadingActions.setLoading(false);
        const data = [...this.state.listData, ...this._listData];
        this.setState({ listData: data });
      })
      .catch(() => loadingActions.setLoading(false));
  };

  private getAll() {
    loadingActions.setLoading(true);
    instrumentActions
      .getAll(
        false,
        this._page,
        CONSTANTS.PAGE_SIZE,
        CONSTANTS.SORT_CREATEDON,
        CONSTANTS.SORT_ORDER,
        ""
      )
      .then(() => {
        this.setState(
          {
            listData: this._listData,
          },
          () => {
            loadingActions.setLoading(false);
            const firstItem = this.state.listData.find(
              (x) => x.id === this.state.activeId
            );
            if (this._reloadFirst) {
              if (this.state.listData.length > 0 && firstItem) {
                this.triggerGetById(firstItem?.id);
              } else {
                const data: IActionHeaderEditData = {
                  moduleName: CONSTANTS.MODULE_INSTRUMENT,
                  editData: {},
                  deleteTitle: CONSTANTS.DELETE_TITLE.format(""),
                  deleteId: "",
                  isEnableViewAll: false,
                  deleteRequestId: uuidv4(),
                  deleteMessage: "",
                };
                actionHeaderActions.edit(data).then();
              }
            } else {
              this.triggerGetById(this._id);
            }
          }
        );
      })
      .catch(() => loadingActions.setLoading(false));
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;
    /// Set Add Button Event
    const instrumentFormData = new InstrumentFormData(
      false,
      uuidv4(),
      CONSTANTS.DefaultGuid,
      "",
      "",
      "",
      { id: "", name: "", description: "" },
      [],
      [],
      "",
      false
    );
    const connectFormData = new ConnectFormData(
      "",
      "",
      "",
      false,
      false,
      "",
      0,
      "",
      "",
      "",
      "",
      [],
      null
    );

    const addRequest = {
      moduleName: CONSTANTS.MODULE_INSTRUMENT,
      createData: {
        instrumentFormData,
        connectFormData,
      },
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();

    if (
      this.props.location.state &&
      this.props.location.state.isReloadFirst !== undefined
    ) {
      this._reloadFirst = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }

    instrumentListStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._listData = [];
        const data = state.instrumentDataList.result as IInstrumentViewData[];
        const items: ISidebarDetail[] = [];
        if (
          state.instrumentDataList.currentPage ===
            state.instrumentDataList.totalPages ||
          state.instrumentDataList.totalRecords === 0
        ) {
          this._hasMore = false;
        } else {
          this._hasMore = true;
        }
        data.forEach((element) => {
          items.push(new SidebarDetail(element.id, element.name));
        });
        this._listData = items;
      }
    });

    instrumentByIdStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this.setState({
          activeItem: state.instrumentData,
          activeId: state.instrumentData.id,
        });
      }
    });

    instrumentDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this.getAll();
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });

    deviceByIdStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this.setState({
          activeConnectionItem: state.deviceData,
        });
      }
    });

    this.getAll();
  }

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="layout-margin">
            <div>
              <React.Fragment>
                {!this.state.collapseSidebar ? (
                  <div>
                    <InstrumentSidebar
                      onCollapseSidebar={this.onCollapseSidebar}
                      onSearch={this.onSearch}
                      searchValue={this.state.searchValue}
                    >
                      <SidebarList
                        onSelectLink={this.onSelectLink}
                        listData={this.state.listData}
                        activeId={this.state.activeId}
                        fetchMore={this.fetchMore}
                        hasMore={this._hasMore}
                        module={CONSTANTS.MODULE_INSTRUMENT}
                      ></SidebarList>
                    </InstrumentSidebar>
                  </div>
                ) : (
                  <div className="sidebar-collapse">
                    <div className="container">
                      <ul className="row nav  justify-content-center sidebar-icons ">
                        <li className="nav-item">
                          <button
                            title="expand"
                            onClick={this.onCollapseSidebar}
                          >
                            <Icon name="abb/caret-right" sizeClass="large" />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </React.Fragment>
            </div>
            <IntrumentOverview
              instrumentData={this.state.activeItem}
              instrumentId={this.state.activeId}
              deviceData={this.state.activeConnectionItem}
              childRef={this._childRef}
              sidebarCollapsed={this.state.collapseSidebar}
            />
          </div>
        )}
      </Translation>
    );
  }
}
